<script setup>
import { IdFuelEnum, TypeSysConfigEnum } from "@/utilities/enum";
</script>
<template>
  <v-data-table-server
    :items-per-page="existing.perPage"
    :headers="
      localDataTable.headers.filter((item) => {
        if (item.title === 'Konfigurasi' && isEdit) {
          return false;
        }
        if (item.title === 'Nama Bahan Bakar' && isEdit) {
          item.width = '45%';
        }
        if (item.title === 'Status' && isEdit) {
          item.width = '45%';
        }
        if (item.title === 'Nama Bahan Bakar' && !isEdit) {
          item.width = '35%';
        }
        if (item.title === 'Status' && !isEdit) {
          item.width = '30%';
        }
        return true;
      })
    "
    :items="localDataTable.items"
    :loading="existing.loading"
    :items-length="existing.totalItems"
    :page="existing.page"
    @update:options="fetchData"
  >
    <template v-slot:item="{ item, index }">
      <tr
        class="border-gray-950 h-14 align-top"
        :class="{
          'bg-gray-50': getIndex(index).displayIndex % 2 === 0,
        }"
      >
        <td class="pt-5 font-medium">
          <h6 class="ml-2">
            {{ getIndex(index).displayIndex }}
          </h6>
        </td>
        <td class="py-2">
          <v-text-field
            :key="item.uuid"
            variant="outlined"
            density="compact"
            placeholder="Nama bahan bakar"
            class="w-full"
            v-model="item.name"
            :id="'name_' + item.uuid + '_' + getIndex(index).displayIndex"
            :rules="formValidasi.name"
            autocomplete="off"
            @input="item.is_touched = true"
            @blur="item.name_touched = true"
            :error="hasErrors(item, 'name')"
            :error-messages="
              existing.items.find((data) => data.uuid === item.uuid)?.duplicate
                ? 'Bahan bakar tidak boleh sama.'
                : getErrors(item, 'name')
            "
            hide-details="auto"
            v-if="isEdit"
            :disabled="item.id === IdFuelEnum.BENSIN"
          ></v-text-field>
          <h6 v-else class="font-medium mt-3">
            {{ item.name }}
          </h6>
        </td>
        <td v-if="!isEdit" class="align-middle">
          <div class="flex gap-3 items-center">
            <div
              class="flex px-2 py-0 font-semibold rounded-full items-center gap-1 cursor-pointer"
              :class="[
                item.sys_config_co2?.length
                  ? 'text-white bg-green-600'
                  : 'text-slate-500 bg-gray-200',
              ]"
              @click="
                sysConfig(
                  TypeSysConfigEnum.CO2,
                  item.name,
                  item.sys_config_co2[0]?.id ?? null,
                  item.id
                )
              "
            >
              <i
                class="mdi"
                :class="[
                  item.sys_config_co2?.length ? 'mdi-check' : 'mdi-close',
                ]"
              ></i>
              <h5 class="text-xs">CO2</h5>
            </div>
            <div
              class="flex px-2 py-0 font-semibold rounded-full items-center gap-1 cursor-pointer"
              :class="[
                item.sys_config_n2o?.length
                  ? 'text-white bg-green-600'
                  : 'text-slate-500 bg-gray-200',
              ]"
              v-if="settings.formula_version === 1"
              @click="
                sysConfig(
                  TypeSysConfigEnum.N2O,
                  item.name,
                  item.sys_config_n2o[0]?.id ?? null,
                  item.id
                )
              "
            >
              <i
                class="mdi"
                :class="[
                  item.sys_config_n2o?.length ? 'mdi-check' : 'mdi-close',
                ]"
              ></i>
              <h5 class="text-xs">N2O</h5>
            </div>
            <div
              class="flex px-2 py-0 font-semibold rounded-full items-center gap-1 cursor-pointer"
              :class="[
                item.sys_config_ch4?.length
                  ? 'text-white bg-green-600'
                  : 'text-slate-500 bg-gray-200',
              ]"
              v-if="settings.formula_version === 1"
              @click="
                sysConfig(
                  TypeSysConfigEnum.CH4,
                  item.name,
                  item.sys_config_ch4[0]?.id ?? null,
                  item.id
                )
              "
            >
              <i
                class="mdi"
                :class="[
                  item.sys_config_ch4?.length ? 'mdi-check' : 'mdi-close',
                ]"
              ></i>
              <h5 class="text-xs">CH4</h5>
            </div>
          </div>
        </td>
        <td class="align-middle">
          <div class="w-fit">
            <label
              class="flex items-center select-none gap-2"
              :class="{ 'cursor-pointer': isEdit }"
            >
              <div class="relative">
                <input
                  type="checkbox"
                  class="sr-only"
                  v-model="item.active"
                  :disabled="!isEdit"
                  @update:model-value="item.is_touched = true"
                />
                <div
                  :class="{
                    'bg-green-600': item.active,
                    'bg-slate-600': !item.active,
                  }"
                  class="block h-6 rounded-full w-11"
                ></div>
                <div
                  :class="{
                    'translate-x-full': item.active,
                  }"
                  class="absolute flex items-center justify-center w-5 h-5 transition bg-white rounded-full left-[2px] top-[2px]"
                ></div>
              </div>
              <span class="text-xs font-medium">
                {{ item.active ? "Active" : "Inactive" }}
              </span>
            </label>
          </div>
        </td>
        <td class="text-center align-middle">
          <img
            src="../../../../assets/icon/trash.png"
            alt="icon"
            loading="lazy"
            class="min-w-6 w-6 cursor-pointer h-auto"
            @click="removeRow(item.existing_index)"
            :id="'remove_' + getIndex(index)?.displayIndex"
          />
        </td>
      </tr>
    </template>
  </v-data-table-server>
</template>

<script>
export default {
  name: "FuelTableComponent",
  props: {
    dataTable: Object,
    existing: Object,
    formValidasi: Object,
    settings: Object,
    isEdit: Boolean,
    addRow: Function,
    removeRow: Function,
    fetchData: Function,
    sysConfig: Function,
  },
  computed: {
    localDataTable: {
      get() {
        return this.dataTable;
      },
      set(newValue) {
        this.$emit("update:dataTable", newValue); // Kirim event ke parent
      },
    },
    indexedData() {
      let counter = 1;
      let startIndex = this.dataTable.start_index ?? 0;
      return this.dataTable.items.map((dt, index) => {
        if (!dt.deleted) {
          return {
            ...dt,
            displayIndex: startIndex + counter++,
            realIndex: index,
          };
        } else {
          return { ...dt, displayIndex: null, realIndex: index };
        }
      });
    },
  },
  methods: {
    getIndex(index) {
      return this.indexedData.find((item) => item.realIndex === index);
    },
    hasErrors(data, touched) {
      return this.getErrors(data, touched).length > 0;
    },
    getErrors(value, touched) {
      if (!value[`${touched}_touched`]) return [];
      const rules = this.formValidasi[touched];
      const errors = rules
        .map((rule) => rule(value[touched]))
        .filter((result) => result !== true);
      return errors;
    },
  },
};
</script>
